export default {
  'text-area': {
    form: { component: { name: 'text-area', span: 24, props: { } } }
  }
}
